import React from 'react';
import { Sparkles, Award, Users, Star } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-[#1a1918] via-[#2d2826] to-[#1a1918] overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#d4af37] rounded-full blur-[120px] animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#ffd700] rounded-full blur-[150px] animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="container mx-auto px-6 py-32 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          {/* Enhanced Inkfly Badge */}
          <div className="inline-flex flex-col items-center mb-8 animate-fadeInUp">
            <div className="flex items-center space-x-4 bg-white/20 backdrop-blur-md border-2 border-white/30 rounded-full px-8 py-4 mb-4 shadow-xl">
              <img 
                src="/assets/images/logos/inkfly-logo.png" 
                alt="Inkfly Logo" 
                className="h-16 w-auto object-contain drop-shadow-lg"
              />
              <div className="text-left">
                <div className="text-[#d4af37] text-lg font-bold drop-shadow-md">From the house of</div>
                <div className="text-white text-2xl font-bold drop-shadow-md">Inkfly Photo Booth</div>
              </div>
            </div>
            <div className="flex items-center space-x-2 text-[#d4af37] text-sm">
              <Star className="w-4 h-4 fill-current" />
              <span className="font-semibold">13+ Years of Excellence</span>
              <Star className="w-4 h-4 fill-current" />
            </div>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight animate-fadeInUp" style={{ animationDelay: '0.1s' }}>
            Premium Photo Booths
            <br />
            <span className="gradient-text">That Create Magic</span>
          </h1>

          <p className="text-xl md:text-2xl text-[#bbb5ae] mb-12 max-w-3xl mx-auto animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
            Unique, grandeur photo booth experiences unavailable elsewhere in the Indian market
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16 animate-fadeInUp" style={{ animationDelay: '0.3s' }}>
            <Button
              onClick={() => scrollToSection('products')}
              size="lg"
              className="bg-gradient-to-r from-[#d4af37] to-[#ffd700] text-[#1a1918] hover:from-[#ffd700] hover:to-[#d4af37] font-semibold px-8 py-6 text-lg shine-effect"
            >
              Explore Our Collection
            </Button>
            <Button
              onClick={() => scrollToSection('rentals')}
              size="lg"
              variant="outline"
              className="border-2 border-[#6B3F3F] text-[#6B3F3F] hover:bg-[#6B3F3F] hover:text-white font-semibold px-8 py-6 text-lg transition-all duration-300"
            >
              Rent from Inkfly
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto animate-fadeInUp" style={{ animationDelay: '0.4s' }}>
            <div className="flex flex-col items-center space-y-2">
              <Award className="w-12 h-12 text-[#d4af37] mb-2" />
              <div className="text-4xl font-bold text-white">13+</div>
              <div className="text-[#bbb5ae]">Years Experience</div>
            </div>
            <div className="flex flex-col items-center space-y-2">
              <Sparkles className="w-12 h-12 text-[#d4af37] mb-2" />
              <div className="text-4xl font-bold text-white">20+</div>
              <div className="text-[#bbb5ae]">Unique Products</div>
            </div>
            <div className="flex flex-col items-center space-y-2">
              <Users className="w-12 h-12 text-[#d4af37] mb-2" />
              <div className="text-4xl font-bold text-white">1000+</div>
              <div className="text-[#bbb5ae]">Happy Clients</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-[#d4af37] rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-[#d4af37] rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;